"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionVideoBannerWidgetDataSchema = void 0;
var zod_1 = require("zod");
var PromotionVideoBannerSchema = zod_1.z.object({
    more: zod_1.z.object({
        title: zod_1.z.string(),
        logMeta: zod_1.z.object({
            object: zod_1.z.string(),
            objectType: zod_1.z.string(),
            objectContainer: zod_1.z.string(),
            widgetTargetTitle: zod_1.z.string(),
        }),
    }),
});
var PromotionVideoBannerItemSchema = zod_1.z.object({
    title: zod_1.z.string(),
    image: zod_1.z.object({
        url: zod_1.z.string(),
        width: zod_1.z.number(),
        height: zod_1.z.number(),
    }),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    logMeta: zod_1.z.object({
        position: zod_1.z.number(),
        deepLinkUri: zod_1.z.string(),
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        promotionBannerRoundedItemTitle: zod_1.z.string(),
    }),
});
/**
 * [V1] 프로모션 비디오 배너 가로형 스와이프 - 응답 스키마 (YDM__NOL_PROMOTION_VIDEO_BANNER_SWIPE__V1, 9.0.0~)
 *
 * @see {@link https://fe-api-doc.dev.yanolja.in/#tag/Banner/paths/~1banner~1v1~1promotion-video-swipe/get}
 */
/**
 *
 */
exports.PromotionVideoBannerWidgetDataSchema = zod_1.z.object({
    header: PromotionVideoBannerSchema,
    rollingInterval: zod_1.z.number(),
    items: zod_1.z.array(zod_1.z.object({
        items: zod_1.z.array(PromotionVideoBannerItemSchema),
    })),
    video: zod_1.z
        .object({
        url: zod_1.z.string(),
        format: zod_1.z.string(),
        isPlayOncePerDay: zod_1.z.boolean(),
    })
        .nullish(),
    logMeta: zod_1.z.object({
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        objectContainer: zod_1.z.string(),
        promotionBannerRoundedGroupId: zod_1.z.string(),
        widgetTargetTitle: zod_1.z.string(),
        widgetPosition: zod_1.z.number().optional(),
    }),
});
